import { jsonGuard } from '@logto/connector-kit';
import { z } from 'zod';
export var LogtoInlineHookKey;
(function (LogtoInlineHookKey) {
    LogtoInlineHookKey["PostFirstFactorVerification"] = "inlineHook.postFirstFactorVerification";
    LogtoInlineHookKey["PostSignIn"] = "inlineHook.postSignIn";
})(LogtoInlineHookKey || (LogtoInlineHookKey = {}));
export const inlineHookExecutionErrorPolicies = Object.freeze(['block', 'allow']);
export const inlineHookGuard = z
    .object({
    script: z.string(),
    environmentVariables: z.record(z.string()).optional(),
    contextSample: jsonGuard.optional(),
    enabled: z.boolean().optional(),
    onExecutionError: z.enum(inlineHookExecutionErrorPolicies).optional(),
})
    .strict();
export const inlineHookTestRequestBodyGuard = z
    .object({
    script: z.string(),
    hookType: z.nativeEnum(LogtoInlineHookKey),
    event: jsonGuard,
    environmentVariables: z.record(z.string()).optional(),
})
    .strict();
